// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__6l_LK","description":"styles_description___AL7B","secondaryDescription":"styles_secondaryDescription__gF3_b","browse":"styles_browse____9r5"};